import React, {useContext, useEffect} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {setUiPopupState} from "../../../actions/A_Popups";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {generateTwoFaToken} from "./AccountTwoFaApi";
import {getRenderErrorMesssage} from "../../../utilities/backend";
import AccountTwoFaPopupInput from "./AccountTwoFaPopupInput";
import AccountTwoFaPopupButtons from "./AccountTwoFaPopupButtons";


const AccountTwoFaPopupContent = (props) => {

  const {formValues} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  useEffect(() => {
    fabricatorsRequest();
  }, []);

  const isSubmitCodeStep = uiPopupContext.twoFaStep === 1;
  const isSuccessStep = uiPopupContext.twoFaStep === 2;

  const fabricatorsRequest = async () => {
    try {
      const response = await generateTwoFaToken(uiPopupContext.fabricatorId);
      if (typeof response !== "string") {
        uiPopupDispatch({
          responseReceived: true,
          errorMessage: getRenderErrorMesssage(response),
        });
      } else {
        uiPopupDispatch({
          twoFaToken: response,
          responseReceived: true,
        });
      }
      console.log("twoFaToken", response);
    } catch (response) {
      uiPopupDispatch({
        errorMessage: getRenderErrorMesssage(response),
        responseReceived: true,
      });
    }
  }

  // console.log("uiPopupContext", uiPopupContext);

  return (
    <div className="pl-1 pt-1 pr-075 flex-item mr-075 flex flex--column">
      {/*<input className="fabricators-popup-search__input mb-05 fabricators-popup-search__input--small"*/}
      {/*       placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}*/}
      {/*       value={uiPopupContext.searchText || ""}*/}
      {/*       onChange={handleInputChange}/>*/}
      <div className="flex-item flex flex--center relative">
        {!uiPopupContext.responseReceived
          ? <div className="ui-loader ui-loader--medium"/>
          : (
            <div className="border-box pt-2 pb-2 pl-6 pr-6 text-center relative">
              <p className="mt-0 mb-1 secondary text-center">
                {isSuccessStep
                  ? <span className="bold color-green">Phone Number Successfully Verified. You May Now Close This Window</span>
                  : isSubmitCodeStep
                    ? <FormattedMessage id={"twoFA.message"}/>
                    : "Please verify the phone number and then click Send SMS button"}
                {isSubmitCodeStep ? <span className="bold color-blue pl-025">{formValues.phone1}</span> : null}
              </p>
              {isSuccessStep ? null : <AccountTwoFaPopupInput/>}
              <AccountTwoFaPopupButtons/>
              {uiPopupContext.errorMessage ? (
                <p className="absolute bold left-0 bottom-0 color-red font--14 mb-0 mt-1 w-full">
                  {uiPopupContext.errorMessage}
                </p>
              ) : null}
            </div>
          )}
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {}
  };
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AccountTwoFaPopupContent)
)
